import { SEARCH_PERSON_SUCCESSFUL_FETCH } from 'reducers/constants';

const initialState = {
    items: []
}

export default function (state = initialState, action) {
    switch (action.type) {
        case SEARCH_PERSON_SUCCESSFUL_FETCH:
            return {
                ...state,
                items: action.payload.slice()
            }

        default:
            return state;

    }
}


// WEBPACK FOOTER //
// ./src/reducers/person/personReducer.js